import React, { useState } from "react";
import { useRouter } from "next/router";

import RootPageLoader from "@packages/common/src/components/skeletons/RootPageLoader";
import { useIsomorphicLayoutEffect } from "@packages/common/src/custom-hooks/useAsync";

import { FRONTEND_SIGNUP_URL } from "../../../common/utils/constants";
import LoginBase from "./LoginBase";

const LearnerLogin: React.FC<{ invitationId: string }> = ({ invitationId }) => {
  const router = useRouter();
  const [email, setEmail] = useState();

  useIsomorphicLayoutEffect(() => {
    if (invitationId) {
      const fetchData = async () => {
        const accountsService = new (
          await import("./../../service/accountsService")
        ).default();

        const { data } = await accountsService.getLearnerInvitaionInfo(
          invitationId
        );
        if (data.has_account) {
          setEmail(data.email);
        } else {
          router.push(
            `${FRONTEND_SIGNUP_URL}?next=${router.query?.next}&invitationId=${invitationId}&email=${data.email}`
          );
        }
      };
      fetchData();
    }
  }, []);

  return email ? <LoginBase email={email} /> : <RootPageLoader />;
};

export default LearnerLogin;
